import React from "react";

const TextArea = ({ name, label, error, ...rest }) => {
  return (
    <div className="form-group">
      <div className="row">
        <label htmlFor={name} className="col-sm-3 col-form-label col-form-label-sm d-flex justify-content-sm-end pe-3 text-muted">{label}:</label>
        <div className="col-sm-8">
          <textarea {...rest} name={name} id={name} className="form-control form-control-sm" placeholder={label} rows="3" ></textarea>
          {error && <div className="alert alert-danger small p-0">{error}</div>}
      </div>
      </div>
    </div>
  );
};

const CommentBox = ({ name, label, error, ...rest }) => {
  return (
    <React.Fragment>
      <textarea {...rest} name={name} id={name} className="form-control form-control-sm my-1" placeholder={label} rows="3" ></textarea>
    </React.Fragment>
  );
};

export { TextArea, CommentBox };
